import { useEffect, useState } from "react"

const Header = ({dataEmpresa,dataUser})=>{
    const [dataempresa, setDataempresa]= useState([])
    const [datauser, setDatauser]= useState([])
    useEffect(()=>{
        if(dataEmpresa){
            setDataempresa(dataEmpresa)
        }
        if(dataUser){
            setDatauser(dataUser)
        }
    },[dataEmpresa,dataUser])
    return(
        <div className="header">
            <div className="empresa">
                <img src={dataempresa.logoPeque} alt="logo" />
                <h1>{dataempresa.title}</h1>
            </div>
            <div className="user">
                <img className="user-avatar"src={datauser.imgUser} alt="user" />
                <span>{datauser.nombre}</span>
            </div>
        </div>
    )
}
export default Header